<script>
import PhMoney from './PhMoney.vue';
import PhUsersFour from './PhUsersFour.vue';
import PhKanban from './PhKanban.vue';
import PhIdentificationCard from './PhIdentificationCard.vue';
import PhCalendar from './PhCalendar.vue';
import PhCube from './PhCube.vue';
import PhRobot from './PhRobot.vue';

import PhGear from './PhGear.vue';
import PhMagicWand from './PhMagicWand.vue';
import PhTextbox from './PhTextbox.vue';
import PhClipboardText from './PhClipboardText.vue';
import PhTag from './PhTag.vue';
import IconamoonDiscountLight from './IconamoonDiscountLight.vue';

export default {
  components: {
    PhMoney,
    PhUsersFour,
    PhKanban,
    PhIdentificationCard,
    PhCalendar,
    PhCube,
    PhRobot,
  },
  computed: {
    navigation() {
      const currentInstance = this;
      function hasPermission(permission) {
        return currentInstance.$membershipHasPermissionTo(permission);
      }
      function isAdminOrSuperAdmin() {
        return currentInstance.$isAdminOrSuperAdmin;
      }

      const accountId = this.$currentAccount.id;

      const items = [
        {
          items: [
            {
              name: 'Διαθέσιμα αιτήματα',
              href: `/c/${accountId}/marketplace/listings`,
              icon: PhUsersFour,
              show: () => hasPermission('read contact request listings'),
            },
            {
              name: 'Διαχείρηση αιτημάτων',
              href: `/c/${accountId}/pipelines`,
              icon: PhKanban,
              show: () => hasPermission('read pipelines'),
            },
            {
              name: 'Τα αιτήματά μου',
              href: `/c/${accountId}/contact-requests`,
              icon: PhIdentificationCard,
              show: () => hasPermission('read contact requests'),
            },
            {
              name: 'Ημερολόγιο',
              href: `/c/${accountId}/calendar`,
              icon: PhCalendar,
            },
          ],
        },
        {
          items: [
            {
              name: 'Φόρμες',
              href: `/c/${accountId}/forms`,
              icon: PhClipboardText,
              show: () => isAdminOrSuperAdmin(),
            },
            {
              name: 'Ταξινομήσεις',
              href: `/c/${accountId}/taxonomies`,
              icon: PhTag,
              show: () => isAdminOrSuperAdmin(),
            },
            {
              name: 'Κουπόνια',
              href: `/c/${accountId}/marketplace/coupons`,
              icon: IconamoonDiscountLight,
              show: () => isAdminOrSuperAdmin(),
            },
            {
              name: 'Προϊόντα',
              href: `/c/${accountId}/acc-products`,
              exact: true,
              icon: PhCube,
              show: () => isAdminOrSuperAdmin(),
            },
            {
              name: 'Προσαρμοσμένες ιδιότητες',
              href: `/c/${accountId}/custom-properties`,
              icon: PhTextbox,
              show: () => isAdminOrSuperAdmin(),
            },
            {
              name: 'Αυτοματισμοί',
              href: `/c/${accountId}/automations`,
              icon: PhRobot,
              show: () => isAdminOrSuperAdmin(),
            },
            {
              name: 'Συναλλαγές',
              href: `/c/${accountId}/marketplace/transactions`,
              icon: PhMoney,
              show: () => isAdminOrSuperAdmin(),
            },
            {
              name: 'Ρυθμίσεις marketplace',
              href: `/c/${accountId}/marketplace/settings`,
              icon: PhGear,
              show: () => isAdminOrSuperAdmin(),
            },
            {
              name: 'Onboarding',
              href: `/c/${accountId}/onboarding`,
              icon: PhMagicWand,
              show: () => isAdminOrSuperAdmin(),
            },
          ],
        },
      ];

      return items;
    },
  },
};
</script>

<template>
  <div class="flex flex-col h-full flex-1 bg-gray-900">
    <div class="flex-1 flex flex-col pb-4 overflow-y-auto pt-8">
      <RouterLink
        v-if="$currentAccount.logo"
        :to="{ name: 'accounts.show', params: { accountId: $currentAccount.id } }"
      >
        <img :src="$currentAccount.logo" class="block rounded w-24 mb-8 mx-auto" />
      </RouterLink>
      <h6 class="text-center text-white mb-6">
        {{ $currentAccount.name }}
      </h6>
      <div class="px-6">
        <nav class="flex flex-1 flex-col">
          <ul role="list" class="flex flex-1 flex-col gap-y-7">
            <li v-for="(group, groupIdx) in navigation" :key="groupIdx">
              <div v-if="group.name" class="text-xs font-semibold leading-6 text-gray-400">
                {{ group.name }}
              </div>
              <ul role="list" class="-mx-2 space-y-1">
                <template v-for="item in group.items">
                  <li v-if="(item.show || (() => true))()" :key="item.name">
                    <RouterLink
                      v-if="item.to"
                      :to="item.to"
                      custom
                      v-slot="{ isActive, isExactActive, href, navigate }"
                    >
                      <a
                        :href="href"
                        :class="[
                          (item.exact ? isExactActive : isActive)
                            ? 'bg-gray-800 text-white'
                            : 'text-gray-400 hover:text-white hover:bg-gray-800',
                          'group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold transition-colors',
                        ]"
                        @click="navigate"
                      >
                        <component
                          v-if="item.icon"
                          :is="item.icon"
                          class="h-6 w-6 shrink-0"
                          aria-hidden="true"
                        />
                        {{ item.name }}
                      </a>
                    </RouterLink>
                    <a
                      v-if="item.href"
                      :href="item.href"
                      :class="[
                        'text-gray-400 hover:text-white hover:bg-gray-800 group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold transition-colors',
                      ]"
                    >
                      <component
                        v-if="item.icon"
                        :is="item.icon"
                        class="h-6 w-6 shrink-0"
                        aria-hidden="true"
                      />
                      {{ item.name }}
                    </a>
                  </li>
                </template>
              </ul>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</template>
